import { createAction } from "@reduxjs/toolkit";
import { UpdateUserBodyType, UsersBodyType, UpdatePasswordBodyType } from "src/types/users";

export const createUser = createAction<UsersBodyType>("createUser");
export const getUsers = createAction("getUsers");
export const getUserById = createAction<{ id: number }>("getUserById");
export const updateUser = createAction<UpdateUserBodyType>("updateUser");
export const updatePassword = createAction<UpdatePasswordBodyType>("updatePassword");
